export const COVER_SHIPMENTS_NOT_FOUND = 'COVER_SHIPMENTS_NOT_FOUND';
export const COVER_SHIPMENTS_ATTACHMENT_UNAVAILABLE = 'COVER_SHIPMENTS_ATTACHMENT_UNAVAILABLE';
export const COVER_SHIPMENTS_ATTACHMENT_MATERIAL_MISMATCH =
  'COVER_SHIPMENTS_ATTACHMENT_MATERIAL_MISMATCH';
export const COVER_SHIPMENTS_LINES_ALREADY_USED = 'COVER_SHIPMENTS_LINES_ALREADY_USED';
export const COVER_SHIPMENTS_INVENTORY_POLICY_BLOCKED =
  'COVER_SHIPMENTS_INVENTORY_POLICY_BLOCKED';
export const COVER_SHIPMENTS_PERMISSION_DENIED = 'COVER_SHIPMENTS_PERMISSION_DENIED';
export const COVER_SHIPMENTS_VALIDATION_FAILED = 'COVER_SHIPMENTS_VALIDATION_FAILED';
